import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TableModule } from 'primeng/table';

import { AtividadeMaterial } from '../models/atividade-material';
import { AtividadeMateriaisService } from './atividade-materiais.service';

@Component({
    selector: 'mf-atividade-material',
    templateUrl: './atividade-materiais.component.html',
    styleUrls: ['atividade-materiais.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        TableModule
    ],
    providers: [AtividadeMateriaisService]
})
export class AtividadeMateriaisComponent implements OnInit {
  atividadeMateriais: AtividadeMaterial[] = [];
  @Input() idAtividade: number = 0;
  loading: boolean = false;

  constructor(
    private atividadeMateriaisService: AtividadeMateriaisService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.loading = true;
    this.getMateriais();
    setTimeout(() => {
      this.atividadeMateriais = this.atividadeMateriais.map((item, index) => ({
        ...item,
        item: index + 1,
      }));
    }, 2500);
  }

  getMateriais() {
    this.atividadeMateriaisService.getAtividadeMateriais(this.idAtividade).subscribe((atvMateriais) => {
      this.atividadeMateriais = atvMateriais;
      this.loading = false;
    });
  }
}
